<template>
  <div class="sign">
    <div class="sign-search">
        <div class="btn-box">
            <van-field
                border
                clickable
					      :readonly="isReadonly"
                size="small"
                placeholder="请选择部门"
                @click="showPicker = true"
                @focus="isReadonly = true"
                @blur="isReadonly = false"
                v-model="search.department"
                is-link
                arrow-direction="down"
                clearable
                clear-trigger="always"
            />
            <van-field size="small" v-model="search.key" placeholder="来源单号/出库单号" :formatter="relationNumberFmt" @keyup.13="getList('search')"/>
            
            <van-field size="small" v-model="search.sku" placeholder="SKU" right-icon="scan" @click-right-icon="scanSku" @keyup.13="getList('search')" @input="getList('search')"/>
        </div>
        <div class="toSearch-box">
            <button class="sign-toSearch" @click="getList('search')">查询</button>
        </div>
    </div>

    <div class="sign-item">
			<template v-if="startSearch">
        <van-loading size="24px" vertical>加载中...</van-loading>
			</template>
			<template v-else>
        <template v-if="list.length">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            :immediate-check="false"
            ref="vList"
            @load="onLoad"
          >
            <ul>
                <li @click="toSignInDetail(item)" v-for="(item,index) in list" :key="index">
                  <div>
                    <div class="sign-list">
                        <p>出库单号：{{item.ioDataNo}}</p>
                        <p>申请用户：{{item.applicationUser}}</p>
                    </div>
                    <div class="sign-list">
                        <p>来源单号：{{item.externalNo}}</p>
                        <p>申请时间：{{item.applicationTime}}</p>
                    </div>
                    <div class="sign-list">
                        <p>部门：{{item.department}}</p>
                        <p>种类\PCS数：{{item.qty}}\{{item.quantity}}</p>
                    </div>
                  </div>
                  <p style="margin: 5px 0;">原因：{{item.applicationReason}}</p>
                </li>
            </ul>
          </van-list>
        </template>
        <template v-else>
          <van-empty image="search" description="暂无数据" />
        </template>
			</template>
    </div>

    <van-popup v-model="showPicker" round position="bottom" @close="pickerClose">
      <van-picker
        show-toolbar
        cancel-button-text="关闭"
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
        @change="onItemChange"
				ref="departmentPicker"
        :item-height="30"
        :visible-item-count="5"
      />
    </van-popup>
  </div>
</template>

<script>
import { Icon, Badge, Picker,Popup,Field, Toast, Empty,List,Loading } from 'vant';
import { getDepartmentList } from '@/api/mobile/signIn_api';
import { getStockIODataList } from '@/api/mobile/otherExWarehouse';
import { mapState } from 'vuex'
import util from "util/date";
import {debounce} from "util/util";
import { mixins } from "../mobileMixins";

export default {
  data() {
    return {
      showPicker: false,
      value: '',
      columns: [],
      search: {
        page: 1,
        pageSize: 10,
        department: '',
        key: '',
        sku: '',
        warehouseId: ''
      },
      list: [],
      departmentList: [],
			loading: false,
			finished: false,
			startSearch: false,
      isReadonly: false
    }
  },

  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
		[List.name]: List,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Field.name]: Field
  },

  mixins: [mixins],

  created() {
    this.init()
  },

	computed: {
		...mapState({ warehouse: state => state.common.warehouse })
	},

  methods: {
    init(){
      const _warehouse = window.localStorage.warehouse ? JSON.parse(window.localStorage.warehouse) : this.warehouse;
      this.$set(this.search,'warehouseId',_warehouse.warehouseId)

      this.getDepartment();
    },
    getDepartment(){
      const user = window.localStorage.user ? JSON.parse(window.localStorage.user) : null;
			const data = {
				orgID: user.organizationId || ''
			}

      getDepartmentList(data).then((res)=>{
        if(res.status === 200){
          const { response } = res

          this.departmentList = response

          let arr = []
          response.forEach((item)=>{
            arr.push(item.departmentName);
          })
          this.columns = arr
        }else{
          Toast.fail(res.msg);
        }
      })
    },
		pickerClose(){
			this.$refs.departmentPicker.confirm()
		},
    onConfirm(val){
      this.$set(this.search,'department',val)
      this.showPicker = false;
    },
    onItemChange(e,value,index){
      function fn(){
        const that = this
        this.$set(this.search,'department',value)
        that.showPicker = false;
      }
      debounce(fn.apply(this),300)
     
    },
    scanSku(){
      let that = this
      this.$wx.scanQRCode({
        needResult: 1,
        desc: 'scanQRCode desc',
        success: function (a) {
          that.$set(that.search,'sku',a.resultStr)
          that.getList('search')
        }
      })
    },
    getList(type){
			if (type === 'search') {
				this.list = []
				this.finished = false
				this.search.page = 1
			}

      const data = {
        ...this.search
      }
			
			if(this.search.page === 1){
				this.startSearch = true
			}
      
      getStockIODataList(data).then(res=>{
        this.loading = false
			  this.startSearch = false
        if(res.status === 200){
          const { pageData, pageCount, pageIndex } = res.response

          if(!pageData.length) Toast('暂无匹配数据');

					try{
            pageData.forEach((row)=>{
              row.estimatedDate = util.formatDate.format(new Date(row.estimatedDate), "yyyy-MM-dd");
            })
					}catch{}

					if (pageCount === pageIndex) {
						this.finished = true
					}

					this.list.push(...pageData)
        }else{
          Toast.fail(res.msg);
        }
      })
    },
    toSignInDetail(item){
      const { stockIODataID } = item
      this.$router.push({path: '/mobile/OtherExWarehouseDetail', query: {stockIODataID}})
    },
		onLoad() {
			this.search.page++

			this.getList()
		},
    relationNumberFmt(v){
      return v.trim()
    }
  },

  watch: {
    $route: async function(newValue, from) {
      this.$nextTick(() => {
				if(newValue.path === '/mobile/mobileMenu'){ 
				    this.list = [];
            this.$set(this.search,'page',1)
            this.$set(this.search,'pageSize',10)
            this.$set(this.search,'department','')
            this.$set(this.search,'key','')
            this.$set(this.search,'sku','')
				}
				if(newValue.path === '/mobile/OtherExWarehouse'){ 
          this.$set(this.search,'key','') 
          if(this.search.department || this.search.sku){
            this.getList('search')
          }
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
    ::v-deep .van-cell{
        border: 1px solid #adadad;
        margin-bottom: 7px;
        padding: 5px 10px;
    }
    .sign{
      background-color: #fbf9fe;
    }
    .sign-search{
        box-sizing: border-box;
        width: 100%;
        padding: 10px 10px 3px 10px;
        display: flex;
    }
    .sign-search .btn-box{
        flex: .6;
    }
    .sign-search .toSearch-box{
        flex: .4;
        margin-left: 3%;
        min-height: 120px;
    }
    .sign-toSearch{
        width: 100%;
        height: 94%;
        min-height: 120px;
        background: linear-gradient(to right, #1d62f0 0%,#19d4fd 100%);
        border-radius: 5px;
        border: 0;
        color: #fff;
        font-size: 20px;
    }
    .toSearch-box{
      vertical-align: top;
    }
    .sign-item{
      border-top: 1px solid #ccc;
    }
    .sign-item li{
      border-bottom: 1px solid #ccc;
      background-color: #fbf9fe;
      padding: 3px 10px;
      font-size: 12px;
    }
    .sign-list{
      display: flex;
      p{
        flex: 1;
        word-break: break-all;
        margin: 5px 0;
      }
    }
    .custom-image .van-empty__image {
      width: 90px;
      height: 90px;
    }
</style>